import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from './../../actions'
import SelectEngineBariki from './../../components/site/select_engine_bariki'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  selectEngineBariki: state.searchFormCondition.selectEngineBariki,
})

const SelectEngineBarikiContainer = connect(mapStateToProps, mapDispatchToProps)(SelectEngineBariki)

export default SelectEngineBarikiContainer
